import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  useScrollTrigger,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChatIcon from "@mui/icons-material/Chat";

const Header = ({ user, onLoginClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 0 });

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
  };

  return (
    <AppBar
      position="sticky"
      elevation={trigger ? 4 : 0}
      sx={{
        background: trigger
          ? "rgba(25, 118, 210, 0.95)"
          : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        backdropFilter: "blur(10px)",
        transition: "all 0.3s ease",
      }}
    >
      <Toolbar>
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <ChatIcon sx={{ mr: 1, fontSize: 28 }} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              letterSpacing: "0.5px",
            }}
          >
            Ask Lucky
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />

        {user ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" sx={{ display: { xs: "none", sm: "block" } }}>
              {user.name}
            </Typography>
            <Avatar src={user.avatar} alt={user.name} sx={{ cursor: "pointer" }} />
          </Box>
        ) : (
          <Button
            color="inherit"
            onClick={onLoginClick}
            variant="outlined"
            sx={{
              borderColor: "rgba(255,255,255,0.5)",
              "&:hover": {
                borderColor: "white",
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            Login
          </Button>
        )}

        <IconButton
          color="inherit"
          onClick={handleMenuOpen}
          sx={{ ml: 2 }}
        >
          <MenuIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              mt: 1,
              minWidth: 180,
            },
          }}
        >
          <MenuItem onClick={() => handleNavigate("/")}>Home</MenuItem>
          <MenuItem onClick={() => handleNavigate("/about")}>About Us</MenuItem>
          <MenuItem onClick={handleMenuClose}>Lucky Stories</MenuItem>
          <MenuItem onClick={handleMenuClose}>Woof!</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
